import React from 'react';

const AwardItem = (props) => (
    <li className="media" >
        <div className="media-left">
            <img alt='' className="media-object" src={props.award.image.image} />
        </div>
        <div className="media-body">
            <div className="pull-right">
                {(() => {
                switch (props.award.recipientTotal) {
                    case 0:
                        return '';
                    case 1:
                        return '1 issued';
                    default:
                        return props.award.recipientTotal + ' issued';
                    }
                })()}
            </div>
            <h4 className="media-heading">{props.award.title} {props.award.type}</h4>
            <p>{props.award.description}</p>
        </div>
    </li>
);


export default AwardItem;


// WEBPACK FOOTER //
// ./src/Awards/AwardItem.js